/**
 * Инициализация authSlice из Secure Storage при загрузке приложения.
 * Stage 7 — миграция на Capacitor Preferences.
 */
import { useEffect } from 'react';
import { useAppDispatch } from '../../store/hooks';
import { initializeAuth } from '../../store/slices/authSlice';

export function AuthInitializer() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  return null;
}
